export const SET_USER="SET_USER";
export const SET_EVENTS="SET_EVENTS";
export const SET_TOKEN="SET_TOKEN";
export const LOG_OUT="LOG_OUT";